import React, { lazy, useEffect } from "react";
import { Box, Container, Grid } from "@mui/material";
import MaxDiscount from "../MAXDISCOUNT";
import ProductCardsList from "./ProductCardsList";
import AllCategoryBanner from "./AllCategoryBanner";
import { useLocation } from "react-router-dom";
import { Helmet } from 'react-helmet-async';
import ProductsBanner from "./ProductsBanner";
const ProductFilter = lazy(() => import("./ProductFilter"));

const Index = () => {
    const searchItem = useLocation();
    const canonicalUrl = `https://www.99gift.in/${searchItem.pathname}`;
    useEffect(() => {
        const targetElement = document.getElementById('target-section');
        if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth' });
        }
    }, [searchItem.search.length]);

    return (
        <React.Fragment>
            <Helmet>
                <title>Explore the Best Gift Cards in India – Shop, Redeem & Enjoy!</title>
                <meta name="description" content="Discover a wide range of gift cards from top brands on 99Gift. From shopping and dining to entertainment and lifestyle, we offer the perfect gift for any occasion" />
                <meta property="og:url" content={canonicalUrl} />
                <meta property="og:title" content="Explore the Best Gift Cards in India – Shop, Redeem & Enjoy!" />
                <meta property="og:description" content="Discover a wide range of gift cards from top brands on 99Gift. From shopping and dining to entertainment and lifestyle, we offer the perfect gift for any occasion" />
                <link rel="canonical" href={canonicalUrl} /> {/* Dynamic Canonical URL */}
            </Helmet>
            {/* Banner Image */}
            <Container maxWidth="false" disableGutters={true}>
                <AllCategoryBanner />
            </Container>

            <Container
                maxWidth="false"
                sx={{
                    mt: 3,
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                }}>

                <MaxDiscount />

            </Container>

            <Container
                maxWidth="xl"
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                }}>
                <Grid container
                    sx={{ mt: 4 }} id="target-section">

                    {/* products filter component */}
                    <Grid item lg={2} >
                        <ProductFilter />
                    </Grid>

                    {/* All products List */}
                    <Grid item lg={10} >
                        <ProductsBanner />
                        <ProductCardsList />
                    </Grid>

                </Grid>
            </Container>
        </React.Fragment>
    )




}
export default Index;